import { render, staticRenderFns } from "./ConfigurationOrderSummary.vue?vue&type=template&id=f79fb6a4"
import script from "./ConfigurationOrderSummary.vue?vue&type=script&lang=js"
export * from "./ConfigurationOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationOrderSummary.vue?vue&type=style&index=0&id=f79fb6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports